import { SVGInterface } from "../../interface";

const Sort = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M15.215 4.66005H10.495L12.855 2.30005L15.215 4.66005ZM10.525 19.3701H15.185L12.855 21.7001L10.525 19.3701ZM6.375 6.27005L1.875 17.73H3.715L4.635 15.28H9.745L10.665 17.73H12.505L8.015 6.27005H6.375ZM5.245 13.64L7.185 8.46005L9.125 13.64H5.245ZM16.005 16.14H22.125V17.73H13.595V16.44L19.515 7.88005H13.635V6.28005H21.935V7.54005L16.005 16.14Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default Sort;
